import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '@/contexts/AppContext';
import { Instagram, Facebook, MessageCircle } from 'lucide-react';
import { useEffect, useState } from 'react';

function TikTokIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"/></svg>
  );
}

export default function Footer() {
  const { t, api } = useApp();
  const [handles, setHandles] = useState({});
  useEffect(() => { api.get('/social/handles').then((r) => setHandles(r.data || {})).catch(() => {}); }, [api]);
  const socials = [
    { key: 'ig', label: 'Instagram', Icon: Instagram, fallback: '#' },
    { key: 'fb', label: 'Facebook', Icon: Facebook, fallback: '#' },
    { key: 'tt', label: 'TikTok', Icon: TikTokIcon, fallback: '#' },
    { key: 'wa', label: 'WhatsApp', Icon: MessageCircle, fallback: '#' },
  ];
  return (
    <footer className="mt-32 bg-foreground text-background" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid grid-cols-2 md:grid-cols-4 gap-12">
        <div className="col-span-2 md:col-span-1">
          <div className="font-display text-2xl tracking-[0.25em]">JJBSTYLISH</div>
          <p className="mt-6 text-sm text-background/70 font-light leading-relaxed max-w-xs">{t('footer.tag')}</p>
        </div>
        <div>
          <div className="overline text-background/60 mb-4">Shop</div>
          <ul className="space-y-3 text-sm font-light">
            <li><Link to="/shop?category=Women" className="link-underline">{t('nav.women')}</Link></li>
            <li><Link to="/shop?category=Handbags" className="link-underline">{t('nav.handbags')}</Link></li>
            <li><Link to="/shop?category=Watches" className="link-underline">{t('nav.watches')}</Link></li>
            <li><Link to="/shop?category=Jewelry" className="link-underline">{t('nav.jewelry')}</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-background/60 mb-4">Discover</div>
          <ul className="space-y-3 text-sm font-light">
            <li><Link to="/designers" className="link-underline">{t('nav.designers')}</Link></li>
            <li><Link to="/editorial" className="link-underline">{t('nav.editorial')}</Link></li>
            <li><Link to="/sell" className="link-underline">{t('nav.sell')}</Link></li>
            <li><Link to="/about" className="link-underline">{t('nav.about')}</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-background/60 mb-4">Service</div>
          <ul className="space-y-3 text-sm font-light">
            <li><Link to="/about#authentication" className="link-underline">Authentication</Link></li>
            <li><Link to="/about#shipping" className="link-underline">Shipping & Returns</Link></li>
            <li><Link to="/about#contact" className="link-underline">Contact</Link></li>
            <li><Link to="/about#faq" className="link-underline">FAQ</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-background/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2" data-testid="social-row">
            <span className="overline text-background/50 mr-3">Follow</span>
            {socials.map(({ key, label, Icon, fallback }) => (
              <a key={key} href={handles[key] || fallback} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-10 h-10 inline-flex items-center justify-center border border-background/20 hover:bg-background hover:text-foreground transition" data-testid={`social-${key}`}>
                <Icon size={16} />
              </a>
            ))}
          </div>
          <div className="overline text-background/50">© 2026 JJBSTYLISH — All Rights Reserved · Authenticated · Curated · Coveted</div>
        </div>
      </div>
    </footer>
  );
}
